/**
 * Analytics, and the switch that is off until somebody turns it on.
 *
 * Both of these used to be the kind of thing a page loads before anyone has
 * had a chance to object — the Google tag was in index.html, running on the
 * first paint. Nothing here runs until startAnalytics is called, and the only
 * caller checks consent first.
 *
 * posthog-js is imported dynamically so that a visitor who says no, or who has
 * not been asked, never downloads it either.
 */
const GA_ID = 'G-KE2PJE0M5D';
const POSTHOG_KEY = 'phc_7wtiMJGEitFuUcW1h2VbpZ28rjXiCjpmCKmHhzSFecg';
const POSTHOG_HOST = 'https://us.i.posthog.com';

let started = false;
let posthog = null;

/**
 * Turning it back off has to mean something before the next page load, so both
 * of these keep a handle on the thing they started. Google reads a global on
 * every call; PostHog needs the instance.
 */
export function stopAnalytics() {
  if (typeof window === 'undefined') return;
  window[`ga-disable-${GA_ID}`] = true;
  posthog?.opt_out_capturing?.();
}

export function startAnalytics() {
  if (typeof window === 'undefined') return;
  window[`ga-disable-${GA_ID}`] = false;
  // Said no, then yes again, without a reload in between.
  if (started) { posthog?.opt_in_capturing?.(); return; }
  started = true;

  const tag = document.createElement('script');
  tag.async = true;
  tag.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(tag);
  window.dataLayer = window.dataLayer || [];
  // gtag pushes `arguments`, so this cannot be an arrow function.
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);

  import('posthog-js')
    .then((module) => {
      posthog = module.default;
      posthog.init(POSTHOG_KEY, { api_host: POSTHOG_HOST, defaults: '2026-05-30' });
    })
    .catch(() => { /* a blocked analytics script is not an application error */ });
}
